import { Form, Input } from "decorator-form";
import { Entity, Field } from "typegraph";

import EntitySelect from "common/form/fields/entitySelect/EntitySelect";
import { ILayout } from "common/form/fields/layout/ILayoutType";
import { IFragmentLayoutConfig } from "core/components/FragmentLayout";
import { FragmentProvider } from "core/components/FragmentProvider";
import entityMeta from "../entityMeta";
import * as kbFragments from "../knowledgeBase/KnowledgeBaseFragments";

@Entity(entityMeta.KB)
class KbIdName {

	@Field()
	public id: any;

	@Field()
	public guid: string;

	@Field()
	public name: string;
}

const knowledgeBaseGuidSelect = EntitySelect.registered({
	entity: KbIdName,
	type: 'one',
	getValue: (o) => o.guid,
	getDefaultValueParams: (guid) => {
		return { guid };
	}
}, 'string');

const kbLayoutInput = FragmentProvider.getLayoutInput(kbFragments);

@Form({title: "Knowledge Base Panel"})
export default class KnowledgeBasePanelConfig {

	@Input({type: knowledgeBaseGuidSelect, title: "Knowledge Base"})
	public knowledgeBaseGuid: string;

	@Input({type: kbLayoutInput, title: "Layout"})
	public layout: ILayout<IFragmentLayoutConfig>;

}



// WEBPACK FOOTER //
// ./src/panels/kb/config/KnowledgeBasePanelConfig.tsx